import React, { Component } from 'react';
import { func, string } from 'prop-types';
import { validate as validator } from 'ui-validator';
import { Page } from '../../components';
import validations from './ja-agreement-validations';
import { submitHeapTracking } from '../../utils/util';
import context from '../../serverContext';
import { heapTrackErrors } from '@shared_modules/baui-heap-tracking';
import { AgreementsCheckBox } from '@shared_modules/local-propulsion/components';
// This file handles agreement for 2nd loan any case for logged in users
// TODO rename to Agreement
// TODO: The html toward the bottom near the agreements is a mess - needs to be cleaned up - we are doing some weird conditional stuff to, like a conditional to include an ending </span> tag?

class JAAgreement extends Component {
  state = {
    model: {
      agreements: this.props.agreements,
      email: undefined, // for 2nd loan, don't send. override the email, pw which are empty strs set previously
      password: undefined,
    },
    validationErrors: {},
  };

  handleCheckboxChange = event => {
    const { name } = event.target;
    const checked = this.state.model.agreements === 'on' ? 'off' : 'on';
    const validationErrors = validator({ [name]: checked }, validations);

    this.setState({
      model: {
        ...this.state.model,
        agreements: checked,
      },
      validationErrors,
    });
  };

  submit = e => {
    if (e) e.preventDefault();

    submitHeapTracking(this.props.isJoint);

    const validationErrors = validator(this.state.model, validations);

    if (!Object.keys(validationErrors).length > 0) {
      this.props.saveValues({
        ...this.state.model,
      });

      this.props.nextLocation();
    } else {
      this.setState({
        validationErrors,
      });
      heapTrackErrors(validationErrors);
    }
  };

  render() {
    const { validationErrors } = this.state;

    return (
      <Page
        title="Almost there!"
        header="Last Step. Check the box and you’ll see your new offer."
        name="agreement"
        goBack={this.props.previousLocation}
        submitHandler={this.submit}
        submitLabel="Get Your Rate"
      >
        <div className="form__input">
          <AgreementsCheckBox
            checked={this.state.model.agreements === 'on'}
            handleCheckboxChange={this.handleCheckboxChange}
            agreementLinks={context.agreementLinks}
            isJoint={this.props.loanType === 'joint'}
            validationErrors={validationErrors}
            isJointAppConsent={this.props.loanType === 'joint'}
          />
        </div>
      </Page>
    );
  }
}

JAAgreement.propTypes = {
  saveValues: func.isRequired,
  previousLocation: func.isRequired,
  nextLocation: func.isRequired,
  loanType: string.isRequired,
  agreements: string.isRequired,
};

export default JAAgreement;

